import { IServerQueryResponse } from "../../interface";

const metaTemplate = require('./view/metaTemplate.handlebars');
const BASE_SELECTOR: string = '.server__cover';

export class GameserverHeaderUI {

  private extraPorts: string = this.$base.find('.extra-ports').text();
  private ipAddress: string = this.$base.find('.server__ip span:first-of-type').text();
  public constructor(private $base: JQuery) {}

  public onScroll(callback: (scrolltop: number) => {}): void {
    $(document).on('scroll', (e) => {
      callback($(window).scrollTop());
    });
  }

  public setSticky(): void {
    this.$base.not('.server__cover--landingpage').addClass("is-sticky");
    if ($('.server__cover--landingpage').length === 0) {
        $('body').addClass("gameserver-header-is-sticky");
    }
  }

  public unsetSticky(): void {
    this.$base.removeClass("is-sticky");
    $('body').removeClass("gameserver-header-is-sticky");
  }

  public getServerId() : number {
    return this.$base.parent().data('server-id');
  }

  public renderMeta(data: IServerQueryResponse, callback: () => void) {
    if (data.queried) {
      data.extraPorts = this.extraPorts;
      data.ipAddress = this.ipAddress;
      this.$base.find('.server__meta').html(metaTemplate({data}));
    } else {
      callback();
    }
  }
}

export function createGameserverHeaderUIInstances(): GameserverHeaderUI[] {
  const $base = $(BASE_SELECTOR);
  const instances: GameserverHeaderUI[] = [];

  $base.each((index, el) => {
    instances.push(new GameserverHeaderUI($(el)));
  });

  return instances;

}
